module.exports = __webpack_public_path__ + "img/user-18.0f8e40df.svg";